import { CLOSED_STATUSES, OPEN_STATUSES, daysUntil } from "@/lib/sk";

/** A case needs the person when something blocks the price: open questions, lines to decide on, a failed reading, a near deadline without a quote, an unread mention or an overdue assignment. */
export function needsYou(p) {
  if (!OPEN_STATUSES.includes(p.status)) return false;
  if (p.open_clarifications || p.calc?.attention || p.reading === "failed") return true;
  if (p.mentions_for_me || p.assignments?.overdue) return true;
  const d = daysUntil(p.tender_deadline);
  return d !== null && d <= 7 && !p.quote;
}

export const SEGMENTS = [
  { key: "alle", label: "Alle", match: (p) => p.status !== "forkastet" },
  { key: "utkast", label: "Påbegynt", match: (p) => p.status === "utkast" },
  { key: "deg", label: "Trenger deg", match: needsYou },
  { key: "nevnt", label: "Nevner meg", match: (p) => Boolean(p.mentions_for_me) },
  { key: "aktive", label: "Aktive", match: (p) => OPEN_STATUSES.includes(p.status) },
  { key: "tilbud", label: "Tilbud", match: (p) => Boolean(p.quote) && OPEN_STATUSES.includes(p.status) },
  { key: "avsluttet", label: "Avsluttet", match: (p) => CLOSED_STATUSES.includes(p.status) },
  { key: "forkastet", label: "Forkastet", match: (p) => p.status === "forkastet" },
];

/** Sections for the «Alle» view – every case lands in exactly one, in the order work happens. */
export const GROUPS = [
  { key: "utkast", label: "Påbegynt", hint: "Ikke opprettet ennå – åpne for å fullføre", match: (p) => p.status === "utkast" },
  { key: "deg", label: "Trenger deg", hint: "Avklaringer, mengder, frister – eller du er nevnt", match: needsYou },
  { key: "aktive", label: "Aktive saker", hint: null, match: (p) => OPEN_STATUSES.includes(p.status) && !p.quote },
  { key: "tilbud", label: "Tilbud", hint: "Saker med frosset tilbudsrevisjon", match: (p) => OPEN_STATUSES.includes(p.status) },
  { key: "avsluttet", label: "Avsluttet", hint: null, match: (p) => CLOSED_STATUSES.includes(p.status), collapsed: true },
  { key: "andre", label: "Andre", hint: null, match: () => true },
];

export function groupCases(rows) {
  const left = [...rows];
  return GROUPS.map((g) => {
    const list = left.filter(g.match);
    list.forEach((p) => left.splice(left.indexOf(p), 1));
    return { ...g, list };
  }).filter((g) => g.list.length);
}

export const SORTS = [
  ["aktiv", "Sist aktiv", (a, b) => (b.updated_at || "").localeCompare(a.updated_at || "")],
  ["frist", "Frist", (a, b) => (a.tender_deadline || "9999").localeCompare(b.tender_deadline || "9999")],
  ["sum", "Sum", (a, b) => (b.calc?.price || 0) - (a.calc?.price || 0)],
  ["kunde", "Kunde", (a, b) => (a.customer?.name || "").localeCompare(b.customer?.name || "", "nb")],
];

export function matchesQuery(p, q) {
  if (!q) return true;
  const s = q.toLowerCase();
  return [p.name, p.customer?.name, p.vessel?.name, String(p.number)].some((x) => (x || "").toLowerCase().includes(s));
}

export const isFixture = (p) => /^fixture\b/i.test(p.name || "") || /^fixture\b/i.test(p.customer?.name || "");
